export interface ProductData {
  id: number
  slug: string
  name: string
  price: number
  rating: number
  reviews: number
  image: string
  gallery?: string[]
  category: string
  shortDescription: string
  description: string
  benefits: string[]
  tag?: string
}

export const products: ProductData[] = [
  {
    id: 1,
    slug: 'madame-jeanette-peper-vlokken',
    name: 'Madame Jeanette Pepervlokken',
    price: 3.99,
    rating: 4.9,
    reviews: 128,
    image:
      'https://cdn.magicpatterns.com/uploads/iyiswgDXuhqdAYG598wEvQ/WhatsApp-Image-2026-02-03-at-15.00.06.jpg',
    category: 'Kruiden',
    shortDescription:
      'De aromatische Madame Jeanette peper met zijn fruitige smaak, gedroogd tot gemakkelijk te doseren vlokken.',
    description:
      'De aromatische Madame Jeanette peper kenmerkt zich door zijn fruitige smaak en mag in de pittige Surinaamse gerechten niet ontbreken. Met onze gedroogde Madame Jeanette pepervlokken en de authentieke smaak krijgt elk gerecht een lekkere Spicy Bite! Met de pepervlokken is de scherpte gemakkelijk te doseren en is het een absolute must in de culinaire keukenkasten.',
    benefits: [
      'Altijd bij de hand',
      'Behoud van de authentieke smaak',
      'Langere houdbaarheid',
      'Gemakkelijk te doseren',
      'En het is gewoon lekker!',
    ],
    tag: 'Bestseller',
  },
  {
    id: 2,
    slug: 'fong-fong-pepre',
    name: 'Fong Fong Pepre',
    price: 8.99,
    rating: 4.8,
    reviews: 95,
    image:
      'https://cdn.magicpatterns.com/uploads/i7phLKsGq8g6aEvhuLcWkd/screencapture-capsin-nl-index-php-product-fong-fong-pepre-2026-07-09-12_43_56.png',
    category: 'Kruiden',
    shortDescription:
      'Onze mix van gemalen pepers voegt een heerlijke pittige kick toe aan al je favoriete gerechten.',
    description:
      'Onze mix van gemalen pepers voegt een heerlijke pittige kick toe aan al je favoriete gerechten. Als je van pittig eten houdt, dan is deze pepermix een absolute must-have in je keuken. Onze Fong Fong pepre zorgt voor een smaakexplosie die je nooit zult vergeten.',
    benefits: [
      'Verse pepers uit Suriname, tijdig gemalen',
      'Pepers zitten vol met vitamines en antioxidanten',
      'Veelzijdig in gebruik',
      'Langere houdbaarheid',
      'Gemakkelijk te doseren',
    ],
    tag: 'Nieuw',
  },
  {
    id: 3,
    slug: 'navullingszakje-madame-jeanette',
    name: 'Navullingszakje Madame Jeanette',
    price: 2.99,
    rating: 4.7,
    reviews: 64,
    image:
      'https://cdn.magicpatterns.com/uploads/q69gSCR37sHVTDk9btsVP1/WhatsApp-Image-2026-02-03-at-10.47.30-1.jpg',
    category: 'Kruiden',
    shortDescription:
      'Bestel nu gemakkelijk onze navullingszakje! Zelfde smaak en kwaliteit voor een lagere prijs.',
    description:
      'Bestel nu gemakkelijk onze navullingszakje! Zelfde smaak en kwaliteit voor een lagere prijs. De aromatische Madame Jeanette peper kenmerkt zich door zijn fruitige smaak en mag in de pittige Surinaamse gerechten niet ontbreken. Duurzaam en voordelig navullen van je eigen Capsin potje.',
    benefits: [
      'Voordelig navullen',
      'Duurzame keuze — minder verpakking',
      'Zelfde authentieke smaak',
      'Langere houdbaarheid',
    ],
  },
  {
    id: 4,
    slug: 'navullingszakje-fong-fong-pepre',
    name: 'Navullingszakje Fong Fong Pepre',
    price: 6.99,
    rating: 4.9,
    reviews: 42,
    image:
      'https://cdn.magicpatterns.com/uploads/75ChLBgbQgktf128nmzey6/WhatsApp-Image-2026-02-03-at-10.47.30.jpg',
    category: 'Kruiden',
    shortDescription:
      'Navul je Fong Fong pepre voordelig en duurzaam met dit handige navullingszakje.',
    description:
      'Navul je Fong Fong pepre voordelig en duurzaam met dit handige navullingszakje. Onze mix van gemalen pepers voegt een heerlijke pittige kick toe aan al je favoriete gerechten. Zelfde smaakexplosie, voordeliger geprijsd.',
    benefits: [
      'Voordelig navullen',
      'Duurzame keuze — minder verpakking',
      'Verse pepers uit Suriname',
      'Veelzijdig in gebruik',
    ],
  },
]

export function getProductBySlug(slug: string): ProductData | undefined {
  return products.find((p) => p.slug === slug)
}
